var MedTorsoe = function (quality) {
  return {
    slot: 'torsoe',
    type: 'med',
    quality: quality,
    armorClass: Math.round(7 + quality * 56),
    speed: quality * 1.5,
  };
};
module.exports = MedTorsoe;
